import React from 'react'
import PropTypes from 'prop-types'

import {
  record as recordPropType,
  printer as printerPropType,
  renderer as rendererPropType,
} from './propTypes'

// Exports
export const CellValue = ({attr, record, renderer}) => {
  let node = null

  if (renderer && typeof renderer[attr] === 'function') {
    node = renderer[attr](record, attr, record[attr])
  } else {
    node = record[attr]
  }

  if (node != null) {
    return (
      <div data-test='CellValue'>{node}</div>
    )
  }

  return null
}

CellValue.propTypes = {
  attr: PropTypes.string.isRequired,
  record: recordPropType.isRequired,
  printer: printerPropType,
  renderer: rendererPropType,
}

export default CellValue
